'use client'

import { useEffect } from 'react'

function ping() {
  fetch('/api/auth/ping', { method: 'POST' }).catch(() => {})
}

export function SessionPing() {
  useEffect(() => {
    ping()

    function onVisible() {
      if (document.visibilityState === 'visible') ping()
    }

    document.addEventListener('visibilitychange', onVisible)
    return () => document.removeEventListener('visibilitychange', onVisible)
  }, [])

  return null
}
